/*
 * ph-beacons.js — home for PostHog "fire-on-render" beacon custom elements.
 *
 * A beacon captures an anchor event the moment it connects to the DOM, so the
 * event fires once per render across every path a surface can appear through:
 * initial page load, combined-listing swap (global.js onVariantChange) and the
 * quick-add modal. This is the right model only for PRESENCE-driven events
 * (product_viewed); interaction-driven events (add_to_cart, cart_viewed) stay
 * at their interaction point. Future beacons live in this file.
 */
(function () {
  // Single guarded capture path for every beacon. posthog is a queuing stub
  // before it finishes loading, so calling capture early is safe.
  function phCapture(event, props) {
    if (typeof window.posthog === 'undefined' || !window.posthog.capture) return;
    try {
      window.posthog.capture(event, props);
    } catch (e) {}
  }

  /*
   * <product-view-beacon data-product-id data-product-name data-price>
   * Fires `product_viewed`. Rendered inside .product__info-container (see
   * snippets/ph-product-beacon.liquid) so it travels with the product markup
   * in every render path.
   */
  class ProductViewBeacon extends HTMLElement {
    connectedCallback() {
      var productId = this.dataset.productId;
      if (!productId) return;

      // Dedup the double-render. The combined-listing swap renders twice —
      // stale/cached then fresh (global.js:1706 & :1790) — and a modal can
      // relocate itself to <body> (global.js:651), each re-firing
      // connectedCallback. Both happen within the same tick, so a short
      // same-id time window absorbs them while still allowing a genuine
      // re-view (swap A→B→A, or opening quick-add) to fire.
      var last = window.__phLastProductView;
      var now = Date.now();
      if (last && last.id === productId && now - last.t < 1000) return;
      window.__phLastProductView = { id: productId, t: now };

      phCapture('product_viewed', {
        product_id: productId,
        product_name: this.dataset.productName || '',
        price: parseFloat(this.dataset.price) || 0,
        source: this.resolveSource(),
      });
    }

    resolveSource() {
      // Quick-add wraps cloned PDP markup — detect by ancestry (takes
      // precedence, and never touches the swap signal below).
      if (this.closest('quick-add-modal')) return 'quick_add';

      // Combined-listing swap sets this right before it injects the new
      // product info. One-shot: read and clear so a later non-swap render
      // falls back to page_load.
      if (window.__phViewSource) {
        var src = window.__phViewSource;
        window.__phViewSource = null;
        return src;
      }

      return 'page_load';
    }
  }

  if (!customElements.get('product-view-beacon')) {
    customElements.define('product-view-beacon', ProductViewBeacon);
  }
})();
